import React, { useEffect, useState } from "react";
import api from "../../util/panelApi";

const fmt = (n) => Number(n || 0).toLocaleString("tr-TR");
const pc = (x, d = 1) => (Number(x) * 100).toFixed(d).replace(".", ",");

/// Mobil oncelikli: tek sutun, buyuk dokunma alanlari (min 44px), buyuk kaydirma topuzu.
const CSS = `
.gc-wrap{max-width:760px;margin:0 auto 18px}
.gc-card{background:#fff;border:1px solid #E2E8F0;border-radius:16px;margin-bottom:14px;box-shadow:0 1px 2px #0001;overflow:hidden}
.gc-hd{display:flex;align-items:center;gap:12px;padding:14px 16px;border-bottom:1px solid #EEF2F7;flex-wrap:wrap}
.gc-ic{width:46px;height:46px;border-radius:12px;display:flex;align-items:center;justify-content:center;font-size:24px;flex:none;background:linear-gradient(135deg,#4aa8ff,#1a56c8)}
.gc-ti{flex:1;min-width:150px}.gc-ti h3{font-size:16px;margin:0;font-weight:800}.gc-ti small{color:#64748B;font-size:12px}
.gc-sw{display:flex;align-items:center;gap:8px;font-size:13px;font-weight:700}
.gc-tg{width:52px;height:30px;border-radius:99px;background:#16A34A;position:relative;cursor:pointer;border:0;transition:.2s;flex:none}
.gc-tg::after{content:"";position:absolute;right:4px;top:4px;width:22px;height:22px;border-radius:50%;background:#fff;transition:.2s}
.gc-tg.off{background:#CBD5E1}.gc-tg.off::after{right:26px}
.gc-bd{padding:16px}
.gc-lab{display:flex;align-items:baseline;justify-content:space-between;font-size:13px;font-weight:700;margin-bottom:8px}
.gc-big{font-size:36px;font-weight:900;color:#1a56c8;line-height:1}.gc-big small{font-size:16px}
.gc-rng{-webkit-appearance:none;appearance:none;width:100%;height:14px;border-radius:99px;outline:none;touch-action:pan-y;background:linear-gradient(90deg,#16A34A 0%,#16A34A var(--p),#E2E8F0 var(--p))}
.gc-rng::-webkit-slider-thumb{-webkit-appearance:none;width:34px;height:34px;border-radius:50%;background:#fff;border:5px solid #1a56c8;box-shadow:0 2px 6px #0003;cursor:pointer}
.gc-rng::-moz-range-thumb{width:26px;height:26px;border-radius:50%;background:#fff;border:5px solid #1a56c8;box-shadow:0 2px 6px #0003;cursor:pointer}
.gc-sc{display:flex;justify-content:space-between;font-size:11px;color:#94A3B8;margin-top:4px}
.gc-tiles{display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:10px;margin:14px 0 4px}
.gc-t{background:#F8FAFC;border:1px solid #E2E8F0;border-radius:12px;padding:10px 14px}.gc-t i{font-style:normal;font-size:12px;color:#64748B;display:block}.gc-t b{font-size:19px}.gc-t u{text-decoration:none;font-size:11.5px;color:#94A3B8;display:block}
.gc-chips{display:flex;gap:8px;flex-wrap:wrap;margin-top:12px;align-items:center}
.gc-chip{font-size:12px;font-weight:700;padding:4px 10px;border-radius:99px;background:#E2E8F0;color:#334155}
.gc-chip.ok{background:#DCFCE7;color:#166534}.gc-chip.warn{background:#FEF3C7;color:#92400E}.gc-chip.bad{background:#FEE2E2;color:#991B1B}
.gc-ft{display:flex;gap:8px;justify-content:space-between;align-items:center;padding:12px 16px;border-top:1px solid #EEF2F7;background:#FAFBFD;flex-wrap:wrap}
.gc-btn{border:0;border-radius:10px;padding:0 18px;min-height:44px;font-weight:700;font-size:14px;cursor:pointer}
.gc-btn.pri{background:#1a56c8;color:#fff}.gc-btn.gh{background:#E2E8F0;color:#334155}.gc-btn.sm{min-height:36px;font-size:12.5px;padding:0 12px}
.gc-btn:disabled{opacity:.5}
.gc-adv{margin-top:14px;border-top:1px dashed #E2E8F0;padding-top:10px}.gc-adv summary{font-size:13px;font-weight:700;color:#475569;cursor:pointer;min-height:36px;display:flex;align-items:center}
.gc-fld{display:flex;flex-direction:column;gap:3px;margin-top:8px;font-size:12.5px;color:#475569}.gc-fld input{min-height:42px;border:1px solid #CBD5E1;border-radius:10px;padding:0 10px;font-size:15px}
.gc-tb{width:100%;border-collapse:collapse;margin-top:8px}.gc-tb td,.gc-tb th{padding:4px 6px;font-size:13px;text-align:left}.gc-tb input{width:100%;min-height:40px;border:1px solid #CBD5E1;border-radius:8px;padding:0 8px;font-size:15px}
.gc-msg{font-size:12.5px;color:#475569}
.gc-pick{display:flex;flex-wrap:wrap;gap:8px;margin-top:6px}.gc-pk{min-height:42px;padding:0 16px;border-radius:10px;border:1px solid #CBD5E1;background:#fff;font-weight:700;font-size:14px;color:#334155}.gc-pk.on{background:#1a56c8;border-color:#1a56c8;color:#fff}
@media (max-width:576px){.gc-hd{padding:12px}.gc-bd{padding:12px}.gc-big{font-size:32px}.gc-ft .gc-btn{flex:1}.gc-btn{min-height:46px}}
`;

const OYUN = [
  { key: "ayvo_fruit", ad: "Fruit AYVO", ikon: "🍒", tur: "Meyve masası · 3x3 · ortak tur", pre: "fruitayvo", stats: "fruitayvoStats", unit: "tur", adv: [{ k: "fruitayvoMaxBetRound", l: "Turda kişi başı en fazla (coin)", d: 200000, min: 10 }] },
  { key: "ayvo_food", ad: "Greedy AYVO", ikon: "🍽️", tur: "Yemek çarkı · ortak tur", pre: "food", stats: "foodStats", unit: "tur", adv: [{ k: "foodMaxBetRound", l: "Turda kişi başı en fazla (coin)", d: 100000, min: 10 }] },
  { key: "ayvo_lucky77", ad: "Lucky 77 AYVO", ikon: "🍒", tur: "Meyve çarkı · ortak tur", pre: "fruit", stats: "fruitStats", unit: "tur", adv: [{ k: "fruitMaxBetRound", l: "Turda kişi başı en fazla (coin)", d: 200000, min: 500 }] },
  { key: "ayvo_yummy", ad: "Yummy AYVO", ikon: "🎰", tur: "5×3 slot · 9 çizgi · Wild, Bonus, Jackpot", pre: "yummy", stats: "yummyStats", unit: "dönüş", note: "Bu oran çizgi ödemeleri içindir. Jackpot payı ayrıca eklenir.", adv: [{ k: "yummyJackpotPct", l: "Jackpot payı (%)", d: 1.5, pct: true, step: 0.5 }, { k: "yummyJackpotSeed", l: "Jackpot başlangıç (coin)", d: 50000, min: 0 }, { k: "yummyJackpotOdds", l: "Jackpot şansı (1/…)", d: 40000, min: 1000 }] },
  { key: "ayvo_rocket", ad: "Rocket AYVO", ikon: "🚀", tur: "Crash · ortak tur", pre: "rocket", stats: "rocketStats", unit: "tur", note: "Oran: hangi çarpanda çekilirse çekilsin uzun vadede dönen pay.", adv: [{ k: "rocketMaxMult", l: "En yüksek çarpan", d: 1000, min: 2 }, { k: "rocketMaxBetRound", l: "Turda kişi başı en fazla (coin)", d: 200000, min: 100 }] },
  { key: "ayvo_fly", ad: "AYVO Fly", ikon: "✈️", tur: "Aviator tarzı crash · ortak tur", pre: "fly", stats: "flyStats", unit: "tur", note: "Oran: hangi çarpanda çekilirse çekilsin uzun vadede dönen pay.", adv: [{ k: "flyMaxMult", l: "En yüksek çarpan", d: 1000, min: 2 }, { k: "flyMaxBetRound", l: "Turda kişi başı en fazla (coin)", d: 200000, min: 100 }] },
  { key: "ayvo_roulette", ad: "Rulet AYVO", ikon: "🎡", tur: "Avrupa ruleti · ortak tur", pre: "roulette", stats: "rouletteStats", unit: "tur", adv: [{ k: "rouletteMaxBetRound", l: "Turda kişi başı en fazla (coin)", d: 500000, min: 100 }] },
  { key: "ayvo_ocean", ad: "Okyanus AYVO", ikon: "🐟", tur: "Balık avlama · güçlendirmeli · tek oyunculu", pre: "ocean", stats: "oceanStats", unit: "atış", note: "Oran: hangi balığı vurursa vursun uzun vadede dönen pay. Iskalayan atış bahsi kaybettirir.", adv: [] },
  { key: "ayvo_slots", ad: "AYVO Slots", ikon: "🎰", tur: "Klasik 3 makara · tek çizgi", pre: "slots", stats: "slotsStats", unit: "dönüş", adv: [] },
  { key: "ayvo_arab", ad: "AYVO Arab Nations", ikon: "🏆", tur: "Bayrak çarkı · ortak tur · x2-x100", pre: "racing", stats: "racingStats", unit: "tur", adv: [{ k: "racingMaxBetRound", l: "Turda kişi başı en fazla (coin)", d: 500000, min: 100 }, { k: "racingMaxItems", l: "Turda en fazla kaç bayrağa oynanır", d: 8, min: 1 }] },
  { key: "ayvo_dragon", ad: "AYVO Dragon Tiger", ikon: "🐯", tur: "Kaplan-ejderha boks · ortak tur · x2 / x22", pre: "dragon", stats: "dragonStats", unit: "tur", adv: [{ k: "dragonMaxBetRound", l: "Turda kişi başı en fazla (coin)", d: 500000, min: 100 }] },
  { key: "ayvo_gems", ad: "AYVO Gems", ikon: "💎", tur: "3×3 slot · 5 çizgi · çarpan rayı · şans çarkı · EX bahis", pre: "gems", stats: "gemsStats", unit: "dönüş", adv: [] },
  { key: "ayvo_olympos", ad: "AYVO Olimpos", ikon: "⚡", tur: "6×5 kümeli slot · tumble · ücretsiz oyun", pre: "olympos", stats: "olymposStats", unit: "dönüş", adv: [] },
  { key: "ayvo_seker", ad: "AYVO Sweet Blast", ikon: "🍭", tur: "6×5 şeker patlatma · tumble · çarpan bombası · çift şans · bonus al", pre: "seker", stats: "sekerStats", unit: "dönüş", adv: [] },
  { key: "ayvo_hotbell", ad: "AYVO Hot Bells", ikon: "🔔", tur: "5×4 · 40 çizgi · wild · yıldız · zil bonusu · MINI/MINOR/MAJOR/GRAND", pre: "hotbell", stats: "hotbellStats", unit: "dönüş", adv: [] },
  { key: "ayvo_kleo", ad: "AYVO Cleopatra's Gold Deluxe", ikon: "👑", tur: "5×3 · 25 çizgi · wild x2 · scatter → 15 bedava dönüş (x3) · jackpot havuzu", pre: "kleo", stats: "kleoStats", unit: "dönüş", note: "Oran jackpot payı (%2) dahil toplam orandır; jackpot kendi havuzundan ödenir.", adv: [] },
  { key: "ayvo_mrrich", ad: "AYVO Mr. Rich", ikon: "🎩", tur: "5×3 · 243 yol · wild · scatter → 10 bedava dönüş (x2) · kasa jackpotları (MINI/MINOR/MAJOR/GRAND, bahis 2.500+)", pre: "mrrich", stats: "mrrichStats", unit: "dönüş", adv: [] },
  { key: "ayvo_bigbass", ad: "AYVO Big Bass", ikon: "🎣", tur: "5×3 · 10 çizgi · scatter → 10/15/20 bedava dönüş · balıkçı para balıklarını toplar · her 4 balıkçı +10 dönüş ve x2/x3/x10", pre: "bigbass", stats: "bigbassStats", unit: "dönüş", adv: [] },
  { key: "ayvo_miami", ad: "AYVO Miami Slot", ikon: "🌴", tur: "5×3 · 20 çizgi · wild · $$ güneş jackpot (3-9 adet, 2x-2000x) · bedava dönüş yok", pre: "miami", stats: "miamiStats", unit: "dönüş", adv: [] },
];

const Toggle = ({ on, onClick, disabled }) => <button className={`gc-tg ${on ? "" : "off"}`} disabled={disabled} onClick={onClick} aria-label="aç/kapat" />;

const Players = ({ pre }) => {
  const [days, setDays] = useState(1);
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    setD(null);
    api.gamePlayers(pre, days).then((r) => r?.status && setD(r));
  }, [open, days, pre]);
  return (
    <details className="gc-adv" onToggle={(e) => setOpen(e.target.open)}>
      <summary>En çok oynayanlar</summary>
      <div className="gc-pick">
        {[[1, "Bugün"], [7, "7 gün"], [30, "30 gün"], [0, "Hepsi"]].map(([v, l]) => (
          <button key={v} className={`gc-pk ${days === v ? "on" : ""}`} onClick={() => setDays(v)}>{l}</button>
        ))}
      </div>
      {!d ? <div style={{ fontSize: 13, color: "#64748B", marginTop: 8 }}>Yükleniyor…</div> : d.list.length === 0 ? <div style={{ fontSize: 13, color: "#64748B", marginTop: 8 }}>Bu aralıkta oynayan yok.</div> : (
        <>
          <div style={{ fontSize: 12, color: "#64748B", marginTop: 8 }}>{d.total.users} kişi oynadı · yatırılan {fmt(d.total.bet)} · ödenen {fmt(d.total.win)}</div>
          <div style={{ overflowX: "auto" }}>
            <table className="gc-tb">
              <thead><tr><th>Kullanıcı</th><th>Yatırdı</th><th>Aldı</th><th>Net</th></tr></thead>
              <tbody>
                {d.list.map((x) => (
                  <tr key={x.userId}>
                    <td>{x.name}<br /><small style={{ color: "#94A3B8" }}>ID {x.uniqueID}</small></td>
                    <td>{fmt(x.bet)}</td>
                    <td>{fmt(x.win)}</td>
                    <td style={{ fontWeight: 700, color: x.net > 0 ? "#DC2626" : "#16A34A" }}>{x.net > 0 ? "+" : ""}{fmt(x.net)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ fontSize: 11, color: "#94A3B8", marginTop: 4 }}>Net = oyuncunun kazancı. Kırmızı: oyuncu kazanmış (kasa kaybetmiş), yeşil: oyuncu kaybetmiş.</div>
        </>
      )}
    </details>
  );
};

const GameCard = ({ o, g, cfg, testerList, reload }) => {
  const pre = o.pre;
  const [rtp, setRtp] = useState(Math.round((Number(cfg[pre + "Rtp"]) || 0.8) * 100));
  const [en, setEn] = useState(cfg[pre + "Enabled"] !== false && g?.isActive !== false);
  const [adv, setAdv] = useState(() => Object.fromEntries(o.adv.map((a) => [a.k, a.pct ? (Number(cfg[a.k] ?? a.d / 100) * 100) : cfg[a.k] ?? a.d])));
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const base = Math.round((Number(cfg[pre + "Rtp"]) || 0.8) * 100);

  useEffect(() => {
    api[o.stats]?.().then((r) => r?.status && setSt(r));
  }, []);

  const save = async () => {
    setBusy(true);
    const body = { [pre + "Rtp"]: rtp / 100 };
    for (const a of o.adv) body[a.k] = a.pct ? Number(adv[a.k]) / 100 : Number(adv[a.k]);
    const r = await api.saveConfig(body);
    setBusy(false);
    setMsg(r?.status ? "Kaydedildi — bir sonraki turdan/dönüşten itibaren geçerli." : r?.message || "Kaydedilemedi");
  };
  const toggle = async () => {
    const next = !en;
    if (!next && !window.confirm(`${o.ad} kapatılsın mı? Oyun listesinden de kalkar.`)) return;
    setBusy(true);
    const [a, b] = await Promise.all([api.saveConfig({ [pre + "Enabled"]: next }), api.saveGame({ key: o.key, isActive: next })]);
    setBusy(false);
    if (a?.status && b?.status) setEn(next);
    else window.alert(a?.message || b?.message || "Kaydedilemedi");
  };
  const testOnly = (g?.testers || []).length > 0;
  const setVis = async (toTest) => {
    if (!toTest && !window.confirm(`${o.ad} HERKESE açılsın mı?`)) return;
    const r = await api.saveGame({ key: o.key, testers: toTest ? testerList : [] });
    if (r?.status) reload();
    else window.alert(r?.message || "Kaydedilemedi");
  };
  const setIos = async () => {
    const next = !g?.ios;
    if (next && !window.confirm("iPhone'da görünür olsun mu? (Apple incelemesi için bilerek açılır)")) return;
    const r = await api.saveGame({ key: o.key, ios: next });
    if (r?.status) reload();
  };
  const durum = rtp < 60 ? ["bad", "Çok sıkı: kullanıcı kaçabilir"] : rtp <= 85 ? ["ok", "Dengeli"] : ["warn", "Cömert: kasa payı ince"];
  const gercek = st ? pc(st.rtp) : "—";
  return (
    <div className="gc-card">
      <div className="gc-hd">
        <div className="gc-ic">{o.ikon}</div>
        <div className="gc-ti">
          <h3>{o.ad}</h3>
          <small>{o.tur}</small>
        </div>
        <div className="gc-sw">
          <span>{en ? "Açık" : "Kapalı"}</span>
          <Toggle on={en} onClick={toggle} disabled={busy} />
        </div>
      </div>
      <div className="gc-bd">
        <div className="gc-lab">
          <span>Geri dönüş oranı</span>
          <span className="gc-big">
            {rtp}
            <small>%</small>
          </span>
        </div>
        <input className="gc-rng" type="range" min="30" max="99" step="1" value={rtp} style={{ "--p": ((rtp - 30) / 69) * 100 + "%" }} onChange={(e) => setRtp(Number(e.target.value))} />
        <div className="gc-sc">
          <span>%30 (kasa güçlü)</span>
          <span>%65</span>
          <span>%99 (kasa zayıf)</span>
        </div>
        <div className="gc-tiles">
          <div className="gc-t">
            <i>Kasada kalan</i>
            <b>%{100 - rtp}</b>
            <u>uzun vadede yatırılanın payı</u>
          </div>
          <div className="gc-t">
            <i>Gerçekleşen oran</i>
            <b>%{gercek}</b>
            <u>{st ? `hedef %${base}` : "veri yok"}</u>
          </div>
          <div className="gc-t">
            <i>Bugün</i>
            <b>
              {fmt(st?.today?.n)} {o.unit}
            </b>
            <u>
              yatırılan {fmt(st?.today?.b)} · ödenen {fmt(st?.today?.p)}
            </u>
          </div>
        </div>
        <div className="gc-chips">
          <span className={`gc-chip ${durum[0]}`}>{durum[1]}</span>
          {st?.jackpot != null && <span className="gc-chip">Jackpot havuzu: {fmt(st.jackpot)}</span>}
          <span className={`gc-chip ${testOnly ? "warn" : "ok"}`}>{testOnly ? `Sadece test hesapları (${(g.testers || []).join(", ")})` : "Herkese açık"}</span>
          <span className={`gc-chip ${g?.ios ? "ok" : ""}`}>iPhone: {g?.ios ? "açık" : "kapalı"}</span>
        </div>
        <div className="gc-chips">
          {testOnly ? (
            <button className="gc-btn sm gh" onClick={() => setVis(false)}>Herkese aç</button>
          ) : (
            <button className="gc-btn sm gh" onClick={() => setVis(true)}>Sadece test hesaplarına döndür</button>
          )}
          <button className="gc-btn sm gh" onClick={setIos}>iPhone: {g?.ios ? "kapat" : "aç"}</button>
        </div>
        {o.note && <div style={{ fontSize: 12, color: "#64748B", marginTop: 10 }}>{o.note}</div>}
        <Players pre={pre} />
        {o.adv.length > 0 && (
          <details className="gc-adv">
            <summary>Gelişmiş ayarlar</summary>
            {o.adv.map((a) => (
              <label className="gc-fld" key={a.k}>
                {a.l}
                <input type="number" inputMode="decimal" min={a.min ?? 0} step={a.step ?? 1} value={adv[a.k]} onChange={(e) => setAdv({ ...adv, [a.k]: e.target.value })} />
              </label>
            ))}
          </details>
        )}
      </div>
      <div className="gc-ft">
        <span className="gc-msg">{msg || "Değişiklik bir sonraki turdan itibaren geçerli olur. Havuz kontrolü oranı korur."}</span>
        <div className="d-flex" style={{ gap: 8 }}>
          <button className="gc-btn gh" onClick={() => setRtp(base)} disabled={rtp === base}>Sıfırla</button>
          <button className="gc-btn pri" onClick={save} disabled={busy}>Kaydet</button>
        </div>
      </div>
    </div>
  );
};

// ----------------------------------------------------------------------------- LUCKY
const Slider = ({ min, max, value, onChange, left, right, mid }) => (
  <>
    <input className="gc-rng" type="range" min={min} max={max} step="1" value={value} style={{ "--p": ((value - min) / (max - min)) * 100 + "%" }} onChange={(e) => onChange(Number(e.target.value))} />
    <div className="gc-sc"><span>{left}</span><span>{mid}</span><span>{right}</span></div>
  </>
);
const Pick = ({ value, opts, onChange, f = fmt }) => (
  <div className="gc-pick">
    {[...new Set([...opts, value])].sort((x, y) => x - y).map((o) => (
      <button key={o} className={`gc-pk ${o === value ? "on" : ""}`} onClick={() => onChange(o)}>{f(o)}</button>
    ))}
  </div>
);
const ppmFrom = (rows, k) => {
  // bahse oranla geri donen satirlari k ile olcekle, 0x satiri kalani alir (toplam tam 1.000.000)
  const out = rows.map((r) => ({ mult: r.mult, w: r.mult === 0 ? 0 : Math.round(r.w * k) }));
  const nz = out.reduce((s, r) => s + r.w, 0);
  const z = out.find((r) => r.mult === 0);
  if (z) z.w = Math.max(0, 1000000 - nz);
  return out;
};
const evOf = (rows) => rows.reduce((s, r) => s + (r.mult * r.w) / 1000000, 0);
const sn = (v) => (v >= 1000000 ? v / 1000000 + "M" : v >= 1000 ? v / 1000 + "K" : v);

const LuckyEngineCard = () => {
  const [d, setD] = useState(null);
  const [base, setBase] = useState([]);
  const [rtp, setRtp] = useState(86);
  const [host, setHost] = useState(10);
  const [en, setEn] = useState(true);
  const [mo, setMo] = useState({ enabled: true, threshold: 200000, durationSec: 60, minPool: 100000 });
  const [sm, setSm] = useState({ enabled: false, triggerThreshold: 5000000, jackpotMult: 1000 });
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const load = async () => {
    const r = await api.luckyEngine();
    if (!r?.status) return setMsg(r?.message || "Lucky ayarı alınamadı");
    const c = r.config;
    setD(r);
    setBase(c.odds.normal);
    setRtp(Math.round(evOf(c.odds.normal) * 100));
    setHost(c.hostPct);
    setEn(c.enabled !== false);
    setMo({ enabled: c.moment.enabled, threshold: c.moment.threshold, durationSec: c.moment.durationSec, minPool: c.moment.minPool });
    setSm({ enabled: c.superMoment.enabled, triggerThreshold: c.superMoment.triggerThreshold, jackpotMult: c.superMoment.jackpotMult });
    setOn(r.rollout.on);
  };
  useEffect(() => {
    load();
  }, []);

  if (!d) return <div className="gc-card"><div className="gc-bd">{msg || "Lucky yükleniyor…"}</div></div>;
  const baseEv = evOf(base) || 0.86;
  const k = rtp / 100 / baseEv;
  const preview = ppmFrom(base, k);
  const zero = preview.find((r) => r.mult === 0)?.w ?? 0;
  // havuza giren (100 - yayinci payi) ile oyuncuya cikan (rtp) farki havuzda birikir; negatifse havuz erir
  const kalan = 100 - host - rtp;
  const durum = kalan < 0 ? ["bad", "Havuz eriyor: ödeme girişten fazla"] : rtp < 60 ? ["bad", "Çok sıkı: kullanıcı kaçabilir"] : kalan < 2 ? ["warn", "Havuz fazlası çok az"] : ["ok", "Dengeli"];
  const geri = ((1000000 - zero) / 10000).toFixed(1).replace(".", ",");

  const save = async () => {
    setBusy(true);
    const r = await api.saveLuckyEngine({ enabled: en, hostPct: host, poolPct: 100 - host, odds: { normal: preview }, moment: mo, superMoment: sm });
    setBusy(false);
    if (r?.status) {
      setMsg("Kaydedildi — yeni çekilişlerde geçerli.");
      load();
    } else setMsg(r?.message || "Kaydedilemedi");
  };
  const rollout = async (all) => {
    if (all && !window.confirm("Yeni Lucky motoru HERKES için açılsın mı?")) return;
    const r = await api.saveConfig({ luckyEngineOn: all });
    if (r?.status) setOn(all);
    else window.alert(r?.message || "Kaydedilemedi");
  };
  const rt = d.stats;
  return (
    <div className="gc-card" style={{ border: "2px solid #1a56c8" }}>
      <div className="gc-hd">
        <div className="gc-ic" style={{ background: "linear-gradient(135deg,#a05ad0,#5b1fb8)" }}>🍀</div>
        <div className="gc-ti"><h3>Şanslı hediye (Lucky)</h3><small>Havuz + defter · her atış ayrı çekiliş</small></div>
        <div className="gc-sw"><span>{en ? "Açık" : "Kapalı"}</span><Toggle on={en} onClick={() => setEn(!en)} /></div>
      </div>
      <div className="gc-bd">
        <div className="gc-lab"><span>Oyuncuya geri dönüş</span><span className="gc-big">{rtp}<small>%</small></span></div>
        <Slider min={30} max={98} value={rtp} onChange={setRtp} left="%30 (kasa güçlü)" mid="%65" right="%98 (kasa zayıf)" />

        <div className="gc-lab" style={{ marginTop: 18 }}><span>Yayıncı payı (elmas)</span><span className="gc-big" style={{ fontSize: 28 }}>{host}<small>%</small></span></div>
        <Slider min={0} max={30} value={host} onChange={setHost} left="%0" mid="%15" right="%30" />

        <div className="gc-tiles">
          <div className="gc-t"><i>Havuzda biriken fark</i><b>%{kalan.toFixed(0)}</b><u>havuza giren %{100 - host} − oyuncuya çıkan %{rtp}</u></div>
          <div className="gc-t"><i>Bir şey geri gelen atış</i><b>%{geri}</b><u>hiçbir şey dönmeyen %{(zero / 10000).toFixed(1).replace(".", ",")}</u></div>
          <div className="gc-t"><i>Ödül havuzu</i><b>{fmt(d.pool.balance)}</b><u>rezerv {fmt(d.pool.reserved)}</u></div>
          <div className="gc-t"><i>Son 24 saat</i><b>{fmt(rt.rounds)} tur</b><u>harcanan {fmt(rt.wagered)} · geri %{pc(rt.ratio)}</u></div>
        </div>
        <div className="gc-chips">
          <span className={`gc-chip ${durum[0]}`}>{durum[1]}</span>
          <span className={`gc-chip ${on ? "ok" : "warn"}`}>{on ? "Herkes yeni motorda" : `Sadece test: ${(d.rollout.testers || []).join(", ") || "—"}`}</span>
          {on ? <button className="gc-btn sm gh" onClick={() => rollout(false)}>Sadece test hesaplarına döndür</button> : <button className="gc-btn sm pri" onClick={() => rollout(true)}>Herkese aç</button>}
        </div>

        <details className="gc-adv">
          <summary>Lucky Moment (oda dolunca geçici cömert dönem)</summary>
          <div className="gc-sw" style={{ marginTop: 8 }}><span>{mo.enabled ? "Açık" : "Kapalı"}</span><Toggle on={mo.enabled} onClick={() => setMo({ ...mo, enabled: !mo.enabled })} /></div>
          <div className="gc-fld">Odada ne kadar şanslı hediye harcanınca başlasın (coin)</div>
          <Pick value={mo.threshold} opts={[100000, 200000, 500000, 1000000]} f={sn} onChange={(v) => setMo({ ...mo, threshold: v })} />
          <div className="gc-fld">Ne kadar sürsün (saniye)</div>
          <Pick value={mo.durationSec} opts={[30, 60, 120, 180]} f={(v) => v + " sn"} onChange={(v) => setMo({ ...mo, durationSec: v })} />
          <div className="gc-fld">Havuzda en az ne kadar olmalı (coin)</div>
          <Pick value={mo.minPool} opts={[50000, 100000, 250000, 500000]} f={sn} onChange={(v) => setMo({ ...mo, minPool: v })} />
          <div className="gc-msg" style={{ marginTop: 8 }}>Dönemde beklenen ödeme %{pc(d.expected.moment)}. Havuz şartı korur.</div>
        </details>
        <details className="gc-adv">
          <summary>Super Moment (garanti büyük jackpot)</summary>
          <div className="gc-sw" style={{ marginTop: 8 }}><span>{sm.enabled ? "Açık" : "Kapalı"}</span><Toggle on={sm.enabled} onClick={() => setSm({ ...sm, enabled: !sm.enabled })} /></div>
          <div className="gc-fld">Tetik eşiği: odada harcanan şanslı hediye (coin)</div>
          <Pick value={sm.triggerThreshold} opts={[2000000, 5000000, 10000000]} f={sn} onChange={(v) => setSm({ ...sm, triggerThreshold: v })} />
          <div className="gc-fld">Jackpot çarpanı</div>
          <Pick value={sm.jackpotMult} opts={[100, 500, 1000]} f={(v) => v + "x"} onChange={(v) => setSm({ ...sm, jackpotMult: v })} />
          <div className="gc-msg" style={{ marginTop: 8 }}>Havuz yetmezse tetiklenmez. Üst ödeme tavanı sunucuda ayarlı.</div>
        </details>
        <details className="gc-adv">
          <summary>Olasılık tablosu (özet, salt okunur)</summary>
          <table className="gc-tb"><tbody>
            {preview.map((r, i) => <tr key={i}><td>{r.mult === 0 ? "Hiçbir şey" : r.mult + "x geri"}</td><td style={{ textAlign: "right" }}>%{(r.w / 10000).toFixed(2).replace(".", ",")}</td></tr>)}
          </tbody></table>
          <div className="gc-msg">Çubuğu oynatınca bu tablo orantılı yeniden hesaplanır (şekil korunur).</div>
        </details>
      </div>
      <div className="gc-ft">
        <span className="gc-msg">{msg || "Değişiklikler kayıt altına alınır."}</span>
        <div className="d-flex" style={{ gap: 8 }}>
          <button className="gc-btn gh" onClick={load}>Sıfırla</button>
          <button className="gc-btn pri" onClick={save} disabled={busy}>Kaydet</button>
        </div>
      </div>
    </div>
  );
};

/// Tek kol: tum oyunlarin oranini birlikte ayarlar (her oyunun <pre>Rtp ayarina ayni degeri yazar) + ortak kasa durumu.
const TumOyunlarCard = ({ cfg }) => {
  const ort = Math.round((OYUN.reduce((t, o) => t + (Number(cfg[o.pre + "Rtp"]) || 0.8), 0) / OYUN.length) * 100);
  const [rtp, setRtp] = useState(ort);
  const [st, setSt] = useState(null);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.ortakHavuzStats().then((r) => r && setSt(r.ozet || r.data || r));
  }, []);
  const save = async () => {
    setBusy(true);
    const body = {};
    OYUN.forEach((o) => (body[o.pre + "Rtp"] = rtp / 100));
    const r = await api.saveConfig(body);
    setBusy(false);
    if (r?.status) {
      OYUN.forEach((o) => (cfg[o.pre + "Rtp"] = rtp / 100));
      setMsg("Kaydedildi: bütün oyunlar %" + rtp + ". (Sayfayı yenileyince kartlarda görünür.)");
    } else setMsg("Kaydedilemedi: " + (r?.message || "hata"));
  };
  return (
    <div className="gc-card">
      <div className="gc-hd">
        <div className="gc-ic">🎛️</div>
        <div className="gc-ti">
          <h3>Bütün Oyunlar · Tek Kol</h3>
          <small>Tek ayarla {OYUN.length} oyunun oranı birlikte değişir · ortak kasa bu orana göre çalışır</small>
        </div>
      </div>
      <div className="gc-bd">
        <div className="gc-lab">
          <span>Oyunculara dönen pay (RTP)</span>
          <span className="gc-big">%{rtp}</span>
        </div>
        <input className="gc-rng" type="range" min="50" max="95" step="1" value={rtp} style={{ "--p": ((rtp - 50) / 45) * 100 + "%" }} onChange={(e) => setRtp(Number(e.target.value))} />
        <div className="gc-sc"><span>%50 (kasa güçlü)</span><span>%80</span><span>%95 (oyuncu güçlü)</span></div>
        <div className="gc-tiles">
          <div className="gc-t"><i>Kasa kârı</i><b>%{100 - rtp}</b><u>oynananın</u></div>
          <div className="gc-t"><i>Şu anki ortalama</i><b>%{ort}</b><u>kayıtlı oranlar</u></div>
          {st && st.bet !== undefined && (
            <div className="gc-t"><i>Gerçekleşen (ortak kasa)</i><b>%{pc(st.rtp || 0, 0)}</b><u>{fmt(st.bet)} oynandı · {fmt(st.paid)} döndü</u></div>
          )}
          {st && st.hedef !== undefined && (
            <div className="gc-t"><i>Kasadaki bütçe</i><b>{fmt(st.hedef - st.paid + (st.seed || 0))}</b><u>dağıtılabilir kazanç</u></div>
          )}
        </div>
        <div className="gc-msg">Not: Lucky 77 en fazla %88 olur. Oyun bazında farklı oran istersen aşağıdaki kartlardan tek tek ayarlayabilirsin.</div>
      </div>
      <div className="gc-ft">
        <span className="gc-msg">{msg}</span>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="gc-btn gh" onClick={() => setRtp(ort)} disabled={rtp === ort || busy}>Sıfırla</button>
          <button className="gc-btn pri" onClick={save} disabled={busy}>{busy ? "Kaydediliyor…" : "Hepsine uygula"}</button>
        </div>
      </div>
    </div>
  );
};

/// Oyuncu kademeleri + akilli kurallar (util/ortakHavuz.js). Oyuncu kazanci = ortak kasa ile kendi kademesinden dusugu.
const kademeOku = (s) =>
  String(s || "")
    .split(",")
    .map((x) => x.trim().split(":"))
    .filter((x) => x.length === 2)
    .map(([a, b]) => ({ sinir: a === "*" ? "" : String(Number(a) || ""), oran: Math.round(Number(b) * 100) || 0 }));

const KademeCard = ({ cfg }) => {
  const [on, setOn] = useState(cfg.oyuncuKatman !== false);
  const [kad, setKad] = useState(kademeOku(cfg.oyuncuKademe || "5000:0.95,50000:0.7,*:0.6"));
  const sayi = (k, d) => (cfg[k] === undefined || cfg[k] === null ? d : Number(cfg[k]));
  const [a, setA] = useState({
    oyuncuSeed: sayi("oyuncuSeed", 3000),
    oyuncuKarOran: Math.round(sayi("oyuncuKarOran", 0.3) * 100),
    akilliBuyukNet: sayi("akilliBuyukNet", 100000),
    akilliSeri: sayi("akilliSeri", 12),
    akilliSeriKat: sayi("akilliSeriKat", 5),
    akilliDonusGun: sayi("akilliDonusGun", 3),
    akilliDonusKredi: sayi("akilliDonusKredi", 3000),
    akilliSarjOran: Math.round(sayi("akilliSarjOran", 0.2) * 100),
    akilliSarjMax: sayi("akilliSarjMax", 20000),
  });
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const setK = (i, f, v) => setKad(kad.map((k, j) => (j === i ? { ...k, [f]: v } : k)));
  const save = async () => {
    // son satir her zaman "ustu" (*) olur; sinirlar kucukten buyuge
    const sirali = kad.slice(0, -1).filter((k) => Number(k.sinir) > 0).sort((x, y) => Number(x.sinir) - Number(y.sinir));
    const son = kad[kad.length - 1];
    const str = [...sirali.map((k) => `${Number(k.sinir)}:${(Number(k.oran) || 0) / 100}`), `*:${(Number(son.oran) || 0) / 100}`].join(",");
    if ([...sirali, son].some((k) => !(Number(k.oran) >= 10 && Number(k.oran) <= 99))) return setMsg("Oranlar %10 ile %99 arasında olmalı.");
    const body = {
      oyuncuKatman: on,
      oyuncuKademe: str,
      oyuncuSeed: Number(a.oyuncuSeed) || 0,
      oyuncuKarOran: (Number(a.oyuncuKarOran) || 0) / 100,
      akilliBuyukNet: Number(a.akilliBuyukNet) || 0,
      akilliSeri: Number(a.akilliSeri) || 0,
      akilliSeriKat: Number(a.akilliSeriKat) || 0,
      akilliDonusGun: Number(a.akilliDonusGun) || 0,
      akilliDonusKredi: Number(a.akilliDonusKredi) || 0,
      akilliSarjOran: (Number(a.akilliSarjOran) || 0) / 100,
      akilliSarjMax: Number(a.akilliSarjMax) || 0,
    };
    setBusy(true);
    const r = await api.saveConfig(body);
    setBusy(false);
    if (r?.status) {
      Object.assign(cfg, body);
      setKad(kademeOku(str));
      setMsg("Kaydedildi, hemen geçerli.");
    } else setMsg("Kaydedilemedi: " + (r?.message || "hata"));
  };
  // bilesen degil fonksiyon: her yazista input yeniden kurulup odak kaybolmasin
  const alan = (k, label, son, w = 90) => (
    <label key={k} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, margin: "4px 0" }}>
      <span style={{ flex: 1 }}>{label}</span>
      <input type="number" className="form-control form-control-sm" style={{ width: w }} value={a[k]} onChange={(e) => setA({ ...a, [k]: e.target.value })} />
      {son ? <span style={{ width: 40 }}>{son}</span> : null}
    </label>
  );
  return (
    <div className="gc-card">
      <div className="gc-hd">
        <div className="gc-ic">🪜</div>
        <div className="gc-ti">
          <h3>Oyuncu Kademeleri</h3>
          <small>Her oyuncu, ortak kasa ile kendi kademesinden hangisi düşükse o oranda kazanır</small>
        </div>
        <label style={{ marginInlineStart: "auto", display: "flex", gap: 6, alignItems: "center", fontSize: 13 }}>
          <input type="checkbox" checked={on} onChange={(e) => setOn(e.target.checked)} /> {on ? "Açık" : "Kapalı (yalnız ortak kasa)"}
        </label>
      </div>
      <div className="gc-bd" style={{ opacity: on ? 1 : 0.5 }}>
        <div className="gc-lab"><span>Oyuncunun toplam bahsine göre oran</span></div>
        {kad.map((k, i) => {
          const sonSatir = i === kad.length - 1;
          const once = i === 0 ? 0 : Number(kad[i - 1].sinir) || 0;
          return (
            <div key={i} style={{ margin: "10px 0 14px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, flexWrap: "wrap" }}>
                <span>{i + 1}. kademe:</span>
                <b>{fmt(once)}</b>
                <span>–</span>
                {sonSatir ? (
                  <b>ve üstü</b>
                ) : (
                  <input type="number" className="form-control form-control-sm" style={{ width: 110 }} value={k.sinir} onChange={(e) => setK(i, "sinir", e.target.value)} />
                )}
                <span>coin bahis</span>
                <span className="gc-big" style={{ marginInlineStart: "auto" }}>%{k.oran}</span>
                {!sonSatir && kad.length > 1 && (
                  <button className="gc-btn gh" onClick={() => setKad(kad.filter((_, j) => j !== i))}>Sil</button>
                )}
              </div>
              <input
                className="gc-rng"
                type="range"
                min="30"
                max="99"
                step="1"
                value={Number(k.oran) || 30}
                style={{ "--p": (((Number(k.oran) || 30) - 30) / 69) * 100 + "%" }}
                onChange={(e) => setK(i, "oran", Number(e.target.value))}
              />
              <div className="gc-sc"><span>%30 (kasa güçlü)</span><span>%65</span><span>%99 (oyuncu güçlü)</span></div>
            </div>
          );
        })}
        <button
          className="gc-btn gh"
          onClick={() => {
            const sonSinir = Number(kad[kad.length - 2]?.sinir) || 0;
            setKad([...kad.slice(0, -1), { sinir: String(sonSinir ? sonSinir * 2 : 10000), oran: kad[kad.length - 1].oran }, kad[kad.length - 1]]);
          }}
        >
          + Kademe ekle
        </button>
        <div className="gc-tiles" style={{ marginTop: 10 }}>
          <div className="gc-t"><i>Ortak kasa (oyun oranı)</i><b>%{Math.round((OYUN.reduce((t, o) => t + (Number(cfg[o.pre + "Rtp"]) || 0.8), 0) / OYUN.length) * 100)}</b><u>üst sınır</u></div>
        </div>
        <div className="gc-lab" style={{ marginTop: 12 }}><span>Akıllı kurallar</span></div>
        {alan("oyuncuSeed", "Yeni oyuncuya başlangıç bütçesi", "coin")}
        {alan("akilliBuyukNet", "Net kârı bunu geçen oyuncu 'büyük kazanan' sayılır", "coin", 110)}
        {alan("oyuncuKarOran", "Büyük kazananın en fazla oranı", "%")}
        {alan("akilliSeri", "Üst üste bu kadar kazançsız oyundan sonra teselli (0 = kapalı)", "oyun")}
        {alan("akilliSeriKat", "Teselli: bahsin en az kaç katı kazanılabilir", "kat")}
        {alan("akilliDonusGun", "Bu kadar gün gelmeyen oyuncuya hoş geldin", "gün")}
        {alan("akilliDonusKredi", "Hoş geldin: %95 oranlı oyun bütçesi", "coin")}
        {alan("akilliSarjOran", "Coin yükleyince yüklediğinin bu kadarı %95 oranlı", "%")}
        {alan("akilliSarjMax", "Yükleme bonusu en fazla", "coin")}
      </div>
      <div className="gc-ft">
        <span className="gc-msg">{msg}</span>
        <button className="gc-btn pri" onClick={save} disabled={busy}>{busy ? "Kaydediliyor…" : "Kaydet"}</button>
      </div>
    </div>
  );
};

export const GameCards = ({ games, reload }) => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    api.config().then((r) => r?.status && setCfg(r.config));
  }, []);
  if (!cfg) return null;
  const testers = cfg.gameTesters && cfg.gameTesters.length ? cfg.gameTesters.map(String) : ["1000"];
  return (
    <div className="gc-wrap">
      <style>{CSS}</style>
      <TumOyunlarCard cfg={cfg} />
      <KademeCard cfg={cfg} />
      <LuckyEngineCard />
      {OYUN.map((o) => (
        <GameCard key={o.key + (games.length ? "1" : "0")} o={o} g={games.find((x) => x.key === o.key)} cfg={cfg} testerList={testers} reload={reload} />
      ))}
    </div>
  );
};

export default GameCards;
